import React from 'react';
import { SessionFieldsFragment } from '../../../../generated/core-api/graphql-react-query';

export interface SessionInfoContextProps {
  sessionId: string | null;
  setSessionId: React.Dispatch<React.SetStateAction<string>>;
  session?: SessionFieldsFragment | null;
  endCause?: string;
  setEndCause: React.Dispatch<React.SetStateAction<string | null>>;
}

export const SessionInfoContext = React.createContext<SessionInfoContextProps | null>(null);

export default function useSessionInfoContext() {
  const context = React.useContext(SessionInfoContext);

  if (!context) {
    throw new Error('useSessionInfoContext must be used within a SessionInfoContextProvider');
  }

  return context;
}
